import { render } from "./CytologySlideReporting.vue?vue&type=template&id=1373013d&scoped=true"
import script from "./CytologySlideReporting.vue?vue&type=script&lang=js"
export * from "./CytologySlideReporting.vue?vue&type=script&lang=js"

import "./CytologySlideReporting.vue?vue&type=style&index=0&id=1373013d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1373013d"]])

export default __exports__